<div class="page-container fa-container container">
  @if (cusip && cusipTitle) {
    <p class="col-12 filter-label">
      Currently filtering results to
      {{ cusipTitle.AnnuityProduct_AnnuityID }} &mdash;
      {{ cusipTitle.AnnuityProduct_Carrier }}
      {{ cusipTitle.AnnuityProduct_Contract }}
    </p>
  }
  <div class="row w-100 controls">
    <form class="col-4" [formGroup]="form">
      <mat-form-field class="col-12 default-select">
        <mat-select
          formControlName="defaultsControl"
          [placeholder]="'Preset Table Filtering and Sorting'"
          (selectionChange)="useDefault($event)"
        >
          @for (opt of defaults; track opt) {
            <mat-option [value]="opt.label">{{ opt.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
    <div class="grid-actions">
      <button
        type="button"
        mat-button
        color="primary"
        class="grid-button"
        (click)="exportToExcel(faGrid)"
      >
        <mat-icon>cloud_download</mat-icon>Download Excel File
      </button>
      <app-grid-column-filter
        [columns]="gridColumns"
        (columnsUpdated)="externalColumnsUpdated($event)"
      />
      <button
        type="button"
        mat-button
        color="primary"
        class="reset-button grid-button"
        (click)="useDefault({ value: 'clear' }, true)"
      >
        <mat-icon>replay</mat-icon>Reset
      </button>
    </div>
  </div>
  <kendo-grid
    #faGrid="kendoGrid"
    class="col-12"
    filterable="menu"
    [kendoGridBinding]="ogData"
    [pageSize]="pageSize"
    [pageable]="true"
    [resizable]="true"
    [columnMenu]="{ columnChooser: false }"
    [sortable]="{ allowUnsort: true, mode: 'multiple' }"
    [sort]="sort"
    [filter]="filter"
    [groupable]="true"
    [group]="group"
    [height]="gridHeight()"
    [navigable]="true"
    (filterChange)="filterChange($event)"
  >
    @for (column of gridColumns; track column) {
      <kendo-grid-column
        [field]="column.DataField"
        [hidden]="isHidden(column.DataField)"
        [title]="column.Label"
        [sortable]="column.Sort"
        [groupable]="column.Group"
        [media]="column.RespVis"
        [width]="column.Width ? column.Width : 150"
        [filterable]="column.Filter"
        [sticky]="column.Sticky"
      >
        @if (column.Sort || column.Filter) {
          <ng-template let-service="service" kendoGridColumnMenuTemplate>
            @if (column.Sort) {
              <kendo-grid-columnmenu-sort [column]="column" [service]="service">
                <kendo-grid-messages
                  [sortAscending]="getFilterMenuText(column.Type, 'asc')"
                  [sortDescending]="getFilterMenuText(column.Type, 'desc')"
                />
              </kendo-grid-columnmenu-sort>
            }
            @if (column.Filter) {
              <kendo-grid-columnmenu-filter
                [column]="column"
                [service]="service"
              >
                <ng-template
                  let-filter="filter"
                  let-filterService="filterService"
                  kendoGridFilterMenuTemplate
                >
                  <kendo-multiselect
                    style="width: 99%"
                    textField="display"
                    valueField="value"
                    placeholder="Filter By..."
                    [data]="filterData[column.DataField]"
                    [valuePrimitive]="true"
                    [value]="filter | filterValues"
                    [fillMode]="'outline'"
                    [filterable]="true"
                    (valueChange)="
                      filterValueChange($event, column.DataField, filterService)
                    "
                    (filterChange)="onFilterChange($event, column.DataField)"
                  />
                </ng-template>
              </kendo-grid-columnmenu-filter>
            }
          </ng-template>
        }
        @if (column.Type === 'integer'; as dataItem) {
          <ng-template let-dataItem kendoGridCellTemplate>
            {{ dataItem[column.DataField] | number: '1.0-0' }}
          </ng-template>
        }
        @if (column.Type === 'integer') {
          <ng-template
            let-group
            let-field="field"
            let-value="value"
            kendoGridGroupHeaderTemplate
          >
            {{ value | number: '1.0-0' }}
          </ng-template>
        }
        @if (column.Type === 'perc'; as dataItem) {
          <ng-template let-dataItem kendoGridCellTemplate>
            {{ dataItem[column.DataField] | percent }}
          </ng-template>
        }
        @if (column.Type === 'perc') {
          <ng-template
            let-group
            let-field="field"
            let-value="value"
            kendoGridGroupHeaderTemplate
          >
            {{ value | percent }}</ng-template
          >
        }
        @if (column.Type === 'perc2'; as dataItem) {
          <ng-template let-dataItem kendoGridCellTemplate>
            @if (
              dataItem[column.DataField] === -9.99 ||
              dataItem[column.DataField] === -999
            ) {
              N/A
            } @else {
              {{
                dataItem[column.DataField] === 'N/A' ||
                dataItem[column.DataField] === 'Uncapped'
                  ? dataItem[column.DataField]
                  : (dataItem[column.DataField] | percent: '1.2')
              }}
            }
          </ng-template>
        }
        @if (column.Type === 'perc2') {
          <ng-template
            let-group
            let-field="field"
            let-value="value"
            kendoGridGroupHeaderTemplate
          >
            {{ value | percent: '1.2' }}</ng-template
          >
        }
        @if (column.Type === 'curr'; as dataItem) {
          <ng-template let-dataItem kendoGridCellTemplate>
            {{ dataItem[column.DataField] | currency }}
          </ng-template>
        }
        @if (column.Type === 'curr') {
          <ng-template
            let-group
            let-field="field"
            let-value="value"
            kendoGridGroupHeaderTemplate
          >
            {{ value | currency }}
          </ng-template>
        }
      </kendo-grid-column>
    }
    <kendo-grid-excel fileName="RightBridge-FA.xlsx" [fetchData]="excelData" />
    <ng-template
      let-totalPages="totalPages"
      let-currentPage="currentPage"
      kendoPagerTemplate
    >
      <kendo-pager-prev-buttons />
      <kendo-pager-numeric-buttons [buttonCount]="buttonCount" />
      <kendo-pager-next-buttons />
      <kendo-pager-input />
      <kendo-pager-info />
      <kendo-pager-page-sizes [pageSizes]="pageSizeOptions" />
    </ng-template>
  </kendo-grid>
  <ngx-loading [show]="loading" />
</div>
